import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL mutation for cash in (top up balance)
export const TOP_UP_BALANCE_MUTATION = gql`
  mutation TopUpBalance($userId: Int!, $data: TopUpInput!) {
    topUpBalance(userId: $userId, data: $data) {
      id
      amount
      credit
      onHold
      currency
    }
  }
`;

// Types for cash in operations
export interface TopUpInput {
  amount: number;
  reason: string;
  wagerEnabled?: boolean;
}

export interface TopUpBalanceResponse {
  id: number;
  amount: number;
  credit: number;
  onHold: number;
  currency: string;
}

// CashIn service class
export class CashInService {
  private static instance: CashInService;

  private constructor() {}

  public static getInstance(): CashInService {
    if (!CashInService.instance) {
      CashInService.instance = new CashInService();
    }
    return CashInService.instance;
  }

  async topUpBalance(
    userId: number,
    data: TopUpInput,
  ): Promise<TopUpBalanceResponse> {
    try {
      const response = await apolloClient.mutate({
        mutation: TOP_UP_BALANCE_MUTATION,
        variables: { userId, data },
      });
      if (response.errors && response.errors.length > 0) {
        throw response.errors[0];
      }
      if (!response.data || !response.data.topUpBalance) {
        throw new Error('No data returned from top up mutation');
      }
      return response.data.topUpBalance as TopUpBalanceResponse;
    } catch (error: any) {
      console.error('Error topping up balance:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const cashInService = CashInService.getInstance();

// Export convenience function
export async function topUpBalance(
  userId: number,
  data: TopUpInput,
): Promise<TopUpBalanceResponse> {
  return cashInService.topUpBalance(userId, data);
}
